import React from 'react';

const BS_GridMedium = () => {
    return (
        <div>
            <h1>BS_GridMedium Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_GridMedium;
